var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-content',[_c('viewer',{attrs:{"content":false,"embed":true,"mode":_vm.mode,"nid":_vm.nuuid,"sid":_vm.suuid,"draft_sid":_vm.draft_suuid,"field":"field_set_form","set-view-mode":_vm.setViewMode},on:{"change-status":function($event){_vm.status = $event}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }